<template>
  <div class="home-box">   
      <v-row >
        <v-col cols="12" lg="4" md="4" offset-md="4" offset-lg="4" sm="12" >
           <div class="ma-2" style="text-align:center" v-if="showLogin">
            <img :src="logo" style="max-width:100px" alt="CPES">
          </div>
        <v-layout row v-if="errors">
          <v-row>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-row>
        </v-layout>
        <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
        <v-card class="pa-1" v-if="showLogin">         
          <v-card-title dark class="mb-2">
            <h5>Sign in to continue to CMS</h5>
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="mdi-account"
                name="username"
                label="Email/Mobile"
                v-model="username"
                @keydown.enter="login"
                hint="If mobile, enter without 0 (777xxxxxx)"
              ></v-text-field>
              <v-text-field
                v-model="password"
                id="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                @keydown.enter="login"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-btn dark color="green" block @click="login" :loading="loading" depressed>Login</v-btn>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <div class="text--left">
                  <v-btn
                    dark
                    color="green"
                    text
                    @click="login"
                    :disabled="loading"
                    depressed
                    link
                    to="/forgot-password"
                  >Forgot Password?</v-btn>
                </div>
              </v-col>                   
            </v-row>
          </v-card-actions>
        </v-card>
        <div style="text-align:center">
          <small >Clubs Performance Evaluation System.</small>        
        </div>
       
        </v-col>
      </v-row>  
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { mapGetters } from "vuex";

export default {
  name: "Login",
  components: { Alert },
  data() {
    return {
      username: this.$route.query.email || "",
      password: "",
      showLogin: true,
      logo: require("@/assets/logo.png")
    };
  },
  mounted() {
    this.onDismissed();
  },
  computed: {
    ...mapGetters("auth", {
      errors: "errors",
      isLogged: "token",
      loading: "loading",
      profile: "profile",
    })
  },

  methods: {
    login() {
      this.$store
        .dispatch("auth/retrieveToken", {
          username: this.username,
          password: this.password
        })
        .then(response => {
          console.log(response.data.roles);
          if (response.status == 200) {
            this.showLogin = false;   
            console.log(response.data.roles.length);
            if(response.data.roles && response.data.roles.length > 1){
              this.$router.push("/switch-role");   
            }else{
               this.$router.push("/"); 
            }
                  
          }
        });
    },

    onDismissed() {
      this.$store.dispatch("auth/clearError");
    }
  }
};
</script>
<style>
.login-page {
  padding-bottom: 100px;
}
</style>

